import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<User | null>;
    public user: Observable<User | null>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')!));
        this.user = this.userSubject.asObservable();
    }

    public get userValue() {
        return this.userSubject.value;
    }

    // login(email: string, password: string) {

    //     return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/login`, { email: email,password:password })
    //     .pipe(map(user => {
    //         localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
    //         return user;
    //     }));
    // }

    login(email: string, password: string) {

        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/login`, { username: email, password: password })
            .pipe(map(user => {
                localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
                return user;
            }));
    }
    grocerylogin(username: string, password: string) {

        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/login`, { username: username,password:password })
            .pipe(map(user => {
                localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
                return user;
            }));
    }

    stafflogin(restaurant_no: any, username: any,password:any) {
        const formData={
            'restaurant_no':restaurant_no,
            'username':username,
            'password':password
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/staff-login`, formData)
            .pipe(map(user => {
                localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
                localStorage.setItem('business_type', user.data.user.business_type);
                localStorage.setItem('permissions', JSON.stringify(user.data.user.permissions));
                // localStorage.setItem(`${environment.appName}` + 'role_id', user.data.user.role_id);
                // localStorage.setItem(`${environment.appName}` + 'user_name', user.data.user.user_name);
                // localStorage.setItem(`${environment.appName}` + 'role_type', user.data.user.role_type);
                return user;
            }));
    }
    Grocerystafflogin(grocery_no: any, username: any, password: any) {
        const formData = {
            'storeNo': grocery_no,
            'username': username,
            'password': password
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/staff-login`, formData)
            .pipe(map(user => {
                localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
                 localStorage.setItem('business_type', user.data.user.business_type);
                 localStorage.setItem('permissions', JSON.stringify(user.data.user.permissions));
                // localStorage.setItem(`${environment.appName}` + 'user_name', user.data.user.user_name);
                // localStorage.setItem(`${environment.appName}` + 'role_type', user.data.user.role_type);
                return user;
            }));
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem(`${environment.appName}` + 'user');
        // localStorage.removeItem(`${environment.appName}` + '_role');
        localStorage.removeItem(`${environment.appName}` + '_userDetails');
        this.userSubject.next(null);
        this.router.navigate(['/login']);
    }

    getstafffacilitiesheader(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/staff/patient/dropdown`)
            .pipe(map(user => {
                localStorage.setItem(`${environment.appName}` + 'facility_id', user.data[0]._id);
                localStorage.setItem(`${environment.appName}` + 'facility_name', user.data[0].fecility_name);
                return user;
            }));
    }


    register(user: User) {
        return this.http.post(`${environment.apiUrl}/users/register`, user);
    }

    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/users`);
    }

    getById(id: string) {
        return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
    }

    update(id: string, params: any) {
        return this.http.put(`${environment.apiUrl}/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue?.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiUrl}/users/${id}`)
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue?.id) {
                    this.logout();
                }
                return x;
            }));
    }

    // One signal
    createOneSignal(user_id: any, player_id: any, user_type: any) {
        const formData = {
            'user_id': user_id,
            'player_id': player_id,
            'user_type': user_type
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onesignal/add`, formData)
            .pipe(map(user => {
                return user;
            }));
    }
}